import servicesGetters from './getters.js'
import axios from 'axios'
import { showSuccess, showError } from '../../index.js'
import router from '@/router'
import DOMPurify from 'dompurify'

export default {
  namespaced: true,
  state () {
    return {
      trainingServiceDetails: [],
      trainingServices: [],
      frontendTS: [],
      frontendTSD: [],
      homeTS: [],
      descriptionsForTS: [],
      blankTSData: {
        id: 0,
        name: '',
        summary: '',
        description: 'Typing description ...',
        subMenuId: 0
      },
      blankTSDData: {
        id: 0,
        name: '',
        description: 'Typing description ...'
      }
    }
  },
  getters: servicesGetters,
  mutations: {
    setTrainingServices (state, payload) {
      state.trainingServices = payload
    },
    setTrainingServiceDetail (state, payload) {
      state.trainingServiceDetails = payload
    },
    setHomeTS (state, payload) {
      state.homeTS = payload
    },
    setDescriptionsForTS (state, payload) {
      state.descriptionsForTS = payload
    },
    setFrontendTS (state, payload) {
      state.frontendTS = payload
    },
    setFrontendTSD (state, payload) {
      state.frontendTSD = payload
    }
  },
  actions: {
    async getHomeTSData (context) {
      await axios.get(context.rootState.API_Url + 'TrainingServices/GetHomeTS').then((response) => {
        const responseData = response.data
        context.commit('setHomeTS', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getTSByFilter (context, { filterQuery }) {
      await axios.get(context.rootState.API_Url + 'TrainingServices/GetTSByFilter', {
        params: {
          filterQuery: filterQuery,
          lang: context.rootState.lang
        }
      }).then((response) => {
        const responseData = response.data
        context.commit('setFrontendTS', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getTSByUrl (context, payload) {
      /* eslint-disable */
      let msg = null
      
      await axios.get(context.rootState.API_Url + `TrainingServices/${payload}`).then((response) => {
        const responseData = response.data
        context.commit('setDescriptionsForTS', responseData)
        msg = responseData.map(item => item.subMenuId)
      }).catch(() => {
        router.push('/no-info')
      })

      return msg
    },
    async getTSSubMenuId (context, { id }) {
      /* eslint-disable */
      let data = null

      await axios.get(context.rootState.API_Url + 'TrainingServices/GetSubId', {
        params: {
          id: id,
        }
      }).then((response) => {
        data = response.data
      }).catch(() => {
        router.push('/no-info')
      })
      
      return data
    },
    async getTSForPages (context, { id }) {
      await axios.get(context.rootState.API_Url + 'TrainingServices/GetTSForPages', {
        params: {
          id: id,
          lang: context.rootState.lang
        }
      }).then((response) => {
        const responseData = response.data
        context.commit('setFrontendTS', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getEnTSAdminData (context, { url }) {
      /* eslint-disable */
      let data = null

      // await axios.get(context.rootState.API_Url + 'TrainingServices/GetEngData', {
      await context.rootState.authAxios.get('/TrainingServices/GetEngData', {
        params: {
          url: url
        }
      }).then((response) => {
        data = response.data
        data.description = DOMPurify.sanitize(data.description)
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })

      if (!data) {
        return context.state.blankTSData
      }
      return data 
    },
    async getTSByPageWithFilter (context, { filteredTerm, pageNumber = 1 }) {
      /* eslint-disable */
      let totalForPage = 1

      // await axios.get(context.rootState.API_Url + 'TrainingServices/GetTrainingServicesByPageWithFilterAdmin', {
      await context.rootState.authAxios.get('/TrainingServices/GetTrainingServicesByPageWithFilterAdmin', {
        params: {
          filteredTerm: filteredTerm,
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data.paginatedData.map(item => ({
          ...item,
          description: DOMPurify.sanitize(item.description)
        }))
        totalForPage = Math.ceil(response.data.totalRecords / 6)
        context.commit('setTrainingServices', responseData)
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn')
      })

      return totalForPage
    },
    // async getTrainingServiceData (context) {
    //   await axios.get(context.rootState.API_Url + 'TrainingServices/').then((response) => {
    //     const responseData = response.data
    //     context.commit('setTrainingServices', responseData)
    //   }).catch((error) => {
    //     console.error('There was an error!', error)
    //   })
    // },
    // Old
    async postTrainingService (context, payload) {
      await context.rootState.authAxios.post('/TrainingServices/', {
        name: payload.name,
        img: payload.img,
        url: payload.url,
        summary: payload.summary,
        description: payload.description,
        routeName: payload.routeName,
        subMenuId: payload.subMenuId,
        subMenus: payload.subMenus,
        isHidden: payload.isHidden,
        lang: payload.lang
      })
      // console.log(payload)
      // .then(() => {
      //   showSuccess('Add successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async updateTrainingService (context, payload) {
      await context.rootState.authAxios.put(`/TrainingServices/${payload.id}`, {
        name: payload.name,
        img: payload.img,
        url: payload.url,
        summary: payload.summary,
        description: payload.description,
        routeName: payload.routeName,
        subMenuId: payload.subMenuId,
        subMenus: payload.subMenus,
        isHidden: payload.isHidden,
        lang: payload.lang
      })
    },
    async deleteTrainingService (context, payload) {
      await context.rootState.authAxios.delete(`/TrainingServices/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async changeStatusTrainingService (context, payload) {
      await context.rootState.authAxios.put(`/TrainingServices/ChangeStatus/${payload}`
      ).then(() => {
        showSuccess('Change status successfully')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async getTrainingServiceDataForDetails (context) {
      let TS = null
      // await axios.get(context.rootState.API_Url + 'TrainingServices/GetTSForTSDetail')
      await context.rootState.authAxios.get('TrainingServices/GetTSForTSDetail').then((response) => {
        TS = response.data
      }).catch((error) => {
        console.error('There was an error!', error)
      })
      return TS
    },
    // TrainingServiceDetail
    async getTSDetailForPages (context, { ids }) {
      await axios.get(context.rootState.API_Url + 'TrainingServiceDetails/GetTSDetailForPages', {
        params: {
          ids: ids.join(','),
          lang: context.rootState.lang
        }
      }).then((response) => {
        const responseData = response.data
        context.commit('setFrontendTSD', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getTSDetailByUrl (context, payload) {
      /* eslint-disable */
      let msg = [1]

      await axios.get(context.rootState.API_Url + `TrainingServiceDetails/${payload}`).then((response) => {
        const responseData = response.data
        if (responseData) {
          context.commit('setDescriptionsForTS', responseData)
          msg = responseData.map(item => item.serviceId)
        } else {
          msg = null
        }
      }).catch(() => {
        router.push('/no-info')
      })

      return msg
    },
    async getEnTSDetailAdminData (context, { url }) {
      /* eslint-disable */
      let data = null

      // await axios.get(context.rootState.API_Url + 'TrainingServiceDetails/GetEngData', {
      await context.rootState.authAxios.get('/TrainingServiceDetails/GetEngData', {
        params: {
          url: url
        }
      }).then((response) => {
        data = response.data
        data.description = DOMPurify.sanitize(data.description)
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })

      if (!data) {
        return context.state.blankTSDData
      }
      return data 
    },
    async getTSDetailByPageWithFilter (context, { filteredTerm, pageNumber = 1 }) {
      /* eslint-disable */
      let totalForPage = 1

      // await axios.get(context.rootState.API_Url + 'TrainingServiceDetails/GetTSDetailByPageWithFilterAdmin', {
      await context.rootState.authAxios.get('/TrainingServiceDetails/GetTSDetailByPageWithFilterAdmin', {
        params: {
          filteredTerm: filteredTerm,
          pageNumber: pageNumber
        }
      }).then((response) => {
        const responseData = response.data.paginatedData.map(item => ({
          ...item,
          description: DOMPurify.sanitize(item.description)
        }))
        totalForPage = Math.ceil(response.data.totalRecords / 10)
        context.commit('setTrainingServiceDetail', responseData)
      }).catch((error) => {
        showError('Đã xảy ra lỗi không mong muốn')
      })

      return totalForPage
    },
    // async getTSvDetailData (context) {
    //   await axios.get(context.rootState.API_Url + 'TrainingServiceDetails/').then((response) => {
    //     const responseData = response.data
    //     context.commit('setTrainingServiceDetail', responseData)
    //   }).catch((error) => {
    //     console.error('There was an error!', error)
    //   })
    // },
    async postTSvDetail (context, payload) {
      await context.rootState.authAxios.post('/TrainingServiceDetails/', {
        name: payload.name,
        url: payload.url,
        serviceId: payload.serviceId,
        routeName: payload.routeName,
        description: payload.description,
        isHidden: payload.isHidden,
        lang: payload.lang
      })
      // console.log(payload)
      // .then(() => {
      //   showSuccess('Add successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async updateTSvDetail (context, payload) {
      await context.rootState.authAxios.put(`/TrainingServiceDetails/${payload.id}`, {
        name: payload.name,
        url: payload.url,
        serviceId: payload.serviceId,
        routeName: payload.routeName,
        description: payload.description,
        isHidden: payload.isHidden,
        lang: payload.lang
      })
      // console.log(payload)
      // .then(() => {
      //   showSuccess('Update successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async deleteTSvDetail (context, payload) {
      await context.rootState.authAxios.delete(`/TrainingServiceDetails/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async changeStatusTSvDetail (context, payload) {
      await context.rootState.authAxios.put(`/TrainingServiceDetails/ChangeStatus/${payload}`
      ).then(() => {
        showSuccess('Change status successfully')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    }
  }
}
